import HelloSign from 'hellosign-embedded';

export function HelloSignClientService($document, HELLOSIGN_CLIENT_EVENT) {
    const service = {};
    const state = this;
    state.client = undefined;
    
    service.createClient = function createClient(clientConfiguration, elementId) {
        const iframeElement = $document.find(`#${elementId}`)[0];
        const client = new HelloSign({
            clientId: clientConfiguration.ClientId,
            testMode: clientConfiguration.TestMode,
            container: iframeElement
        });
        service.setClient(client);
    };
    
    service.setClient = function setClient(client) {
        state.client = client;
    };
    
    service.open = function open(templateUrl, options) {
        state.client.open(templateUrl, options);
    };
    
    service.close = function close() {
        state.client.close();
    };
    
    service.onReady = function onReady(fn) {
        state.client.once(HELLOSIGN_CLIENT_EVENT.Ready, fn);
    };
    
    service.setOneTimeHelloSignEventListener = function setOneTimeHelloSignEventListener(helloSignEvent, fn) {
        state.client.once(helloSignEvent, fn);
    };
    
    return service;
}

HelloSignClientService.$inject = ['$document', 'HELLOSIGN_CLIENT_EVENT'];
